/**
 * Mock de pacientes registrados.
 */

export const MOCK_PATIENTS_TOTAL = 4520;
export const MOCK_PATIENTS_TODAY = 18;
export const MOCK_PATIENTS_SPARK = [8, 12, 5, 15, 10, 9, 14, 11, 16, 18];
